import { Component, OnInit } from '@angular/core';
import { MasterMappingModel } from '../master-mappings.model';
import { GlobalService } from '../../shared/services/global.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { ToastrMessageType } from '../../shared/enums/toastr-message-type.enum';
// import 'rxjs/add/observable/forkJoin';

@Component({
  selector: 'app-master-mappings-browse',
  templateUrl: './master-mappings-browse.component.html',
  styleUrls: ['./master-mappings-browse.component.scss']
})
export class MasterMappingsBrowseComponent implements OnInit {

  private masterMappings: MasterMappingModel[] = [];
  private currentMasterMapping: MasterMappingModel;

  private loadingVisible = false;
  private deletePopupVisible = false;

  constructor(
      private router: Router,
      private globalService: GlobalService) {
        this.getMasterMappings();
  }

  ngOnInit() {
  }

  getMasterMappings() {
    this.loadingVisible = true;
    this.globalService.httpGet('/MasterMappings')
      .finally(() => this.loadingVisible = false)
      .subscribe(response => {
        this.masterMappings = response as MasterMappingModel[];
      });

  }

  private showPopup(currentMasterMapping: MasterMappingModel) {
    this.currentMasterMapping = currentMasterMapping;
    this.deletePopupVisible = true;
  }

  private deleteMasterMapping() {
    if (this.currentMasterMapping) {

      this.loadingVisible = true;
      this.globalService.httpPost(`/MasterMappings/Delete/${this.currentMasterMapping.MasterMappingId}`)
        .finally(() => {
          this.loadingVisible = false;
          this.deletePopupVisible = false;
        })
        .subscribe(response => {
          this.globalService.showMessage('Master Mapping was deleted successfully.', ToastrMessageType.Success);
          this.getMasterMappings();
        });
    }
  }

  get diagnostic() { return JSON.stringify(this.masterMappings); }
}
